import { Component, OnInit } from '@angular/core';

@Component({
    templateUrl: './storeApp.component.html',
    styleUrls: ['./storeApp.component.css'],
})

export class StoreAppComponent implements OnInit {
  constructor(
  ) {}

  ngOnInit() {
  }
}
